





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import ScheduledFeesDialogForm from '@/components/Products/ProductFees/Scheduled/ScheduledFeesDialogForm.vue';
import CreateScheduledFeeRequest from '@/models/Products/ProductFees/CreateScheduledFeeRequest';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'ScheduledFeesCreateDialog', components: { ScheduledFeesDialogForm } })
export default class extends SaascadaVueDialog {

    dialog = false;
    scheduledFeeRequest: CreateScheduledFeeRequest = new CreateScheduledFeeRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.scheduledFeeRequest = new CreateScheduledFeeRequest();
        }
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.createScheduledFee(this.scheduledFeeRequest);
        }
    }

}
